export default {
  "fullName": "Matthew Smith",
  "preferredName": "Matt",
  "phone": "613-445-9876",
  "fullAddress": "44 Mt Hope Rd, Petawawa, ON K8H 3P1",
  "email": "matt.smith22@gmail.com",
  "preferredLanguageWritten": "English",
  "preferredLanguageSpoken": "English",
  "emailNotifications": "On",
  "outcan": true
}
